import React, { useEffect, useState } from 'react';
import { States } from '@/helpers/common/states';
import api, { AxiosError } from '@/services/api';
import { toast } from 'react-toastify';
import { EventSectionSaleProductReport } from '@/model/EventSectionSaleProductReport';
import { ReportControllerProps } from '../../types';
import { SaleProductSectionsContent } from './ui';

interface StateProps {
  reportController: ReportControllerProps;
  setState: (state: States) => void;
}

export const SaleProductSections: React.FC<StateProps> = ({
  reportController,
  setState,
}): JSX.Element => {
  const { eventId, singleEvent } = reportController;
  const [sections, setSections] = useState<EventSectionSaleProductReport[]>([]);
  const [allSections, setAllSections] = useState<EventSectionSaleProductReport[]>([]);

  const [sectionId, setSectionId] = useState<string>('');
  const [productName, setProductName] = useState<string>('');
  const [serialNumber, setSerialNumber] = useState<string>('');

  const handleGetSaleProducts = async (
    filterSection = sectionId,
    filterProduct = productName,
    filterSerial = serialNumber,
  ): Promise<void> => {
    try {
      setState(States.loading);

      const params = new URLSearchParams();
      params.append('singleEvent', String(singleEvent));
      if (filterSection) {
        params.append('sectionId', filterSection);
      }
      if (filterProduct.trim()) {
        params.append('productName', filterProduct.trim());
      }
      if (filterSerial.trim()) {
        params.append('serialNumber', filterSerial.trim());
      }

      const { data } = await api.get<EventSectionSaleProductReport[]>(
        `event/report/${eventId}/sale-product/section?${params.toString()}`,
      );
      if (data) {
        setSections(data);
        if (allSections.length === 0) {
          setAllSections(data);
        }
      }
    } catch (error) {
      const err = error as AxiosError;
      toast.error(err.message);
    } finally {
      setState(States.default);
    }
  };

  const handleClearFilter = (): void => {
    setSectionId('');
    setProductName('');
    setSerialNumber('');
    handleGetSaleProducts('', '', '');
  };

  useEffect(() => {
    handleGetSaleProducts();
  }, [singleEvent]);

  return (
    <SaleProductSectionsContent
      sections={sections}
      allSections={allSections}
      sectionId={sectionId}
      productName={productName}
      serialNumber={serialNumber}
      onChangeSectionId={setSectionId}
      onChangeProductName={setProductName}
      onChangeSerialNumber={setSerialNumber}
      onFilter={() => handleGetSaleProducts()}
      onClearFilter={handleClearFilter}
    />
  );
};
